import { goStatsDetailAction } from '@op/pages/stats/Detail';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import type { IEventItem } from '@op/components/ChartsEvents/types';

export const INTELLIGENCE_OPINION_EVENT_DETAILS_PATH =
  '/intelligence/topCharts/eventDetails';

export interface IOpinionEventDetailsGroup {
  name: string;
  name_cn?: string;
  elements: IEventItem[];
}

export interface IGoOpinionEventDetailsParams {
  list: IOpinionEventDetailsGroup[];
  time: string;
}

/** KPI Trends 等情报页跳转事件详情，参数传递逻辑与舆情一致 */
export function goOpinionEventDetails(
  params: IGoOpinionEventDetailsParams,
): void {
  goStatsDetailAction({
    path: INTELLIGENCE_OPINION_EVENT_DETAILS_PATH,
    params: {
      list: params.list,
      time: params.time,
    },
  });
  buriedBtnPoint('KMLG_EventaxisMore');
}
